import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const links = [
  { text: 'Work', to: '/', exact: true },
  { text: 'Service', to: '/service' },
  { text: 'Clients', to: '/clients' },
  { text: 'Directors', to: '/directors' },
  { text: 'Locations', to: '/locations' },
  { text: 'Contact', to: '/contact' },
];

export default class Navigation extends React.PureComponent {
  render() {
    const { isActive, delayedDeactivate } = this.props;

    return (
      <nav className={`Navigation ${
        isActive ? 'Navigation--active' : ''
      }`}
      >
        <ul className="Navigation__list">
          {links.map((link) => (
            <li
              className="Navigation__list-item"
              key={link.text}
            >
              <NavLink
                className="Navigation__link"
                to={link.to}
                exact={link.exact ? link.exact : false}
                onClick={delayedDeactivate}
              >
                <span aria-label="Work" className="Navigation__container">
                  <span aria-hidden="true" className="Navigation__inner">
                    {link.text.split('').map((letter, i) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <span className="Navigation__core" key={i}>
                        <span className="Navigation__letter Navigation__letter--1">
                          {letter}
                        </span>
                        <span className="Navigation__letter Navigation__letter--2">
                          {letter}
                        </span>
                      </span>
                    ))}
                  </span>
                </span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    );
  }
}

Navigation.propTypes = {
  isActive: PropTypes.bool,
  delayedDeactivate: PropTypes.func.isRequired,
};

Navigation.defaultProps = {
  isActive: false,
};
